import { getCanonicalToolName } from "../HomePage/toolRoutes";

export function readFavoriteTools() {
    const saved = JSON.parse(localStorage.getItem("favoriteTools") || "[]");
    // Resolve old display names and merge favorites saved under both names.
    return Array.from(new Map(saved.map(tool => {
        const toolName = getCanonicalToolName(tool.toolName);
        return [toolName, { ...tool, toolName }];
    })).values());
}
